import { Injectable } from "@angular/core";

declare var $: any;

@Injectable()
export class CrowdinService {
    private useCrowdin: Boolean = false;
    
    public UseCrowdin(): void {
        this.useCrowdin = true;

        var html = `
        <script type="text/javascript">
            var _jipt = [];
            _jipt.push(['project', 'isb-elara']);
            _jipt.push(['preload_texts', true]);
        </script>
        <script type="text/javascript" src="//cdn.crowdin.com/jipt/jipt.js"></script>
        `;

        $('head').append(html);
    }

    public IsUsingCrowdin(): Boolean {
        return this.useCrowdin;
    }
}